import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { User } from './types/User';

interface Query {
  expand?: 'defaults';
}

const getUser =
  (makeCall: MakeCall) =>
  (userId: number | 'me' = 'me', query?: Query) =>
    makeCall<User>('GET', `/api/v2/user/${userId}`, {
      query,
    });

export default getUser;
